import { Model } from '@vuex-orm/core'

export default class Posting extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'postings'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      job_id: this.attr(null),
      job_board: this.attr(null),
      status: this.attr(null),
      status_sync: this.attr(null),
      extra_fields: this.attr(null),
      error: this.attr(null),
      desired: this.attr({}),
      phase: this.attr({})
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Posting.js